<h2 mat-dialog-title class="team-title">
  Assigned to Me
  <small>
    {{ team.length }} {{ team.length === 1 ? "employee" : "employees" }}
  </small>
</h2>
<button type="button" class="dialog-btn-close" (click)="close()"></button>

<mat-dialog-content>
  @if (!isLoading && team.length) {
    <div class="team-search">
      <i class="fa fa-search" aria-hidden="true"></i>
      <input
        type="text"
        placeholder="Search by name, email, emp ID, SAP code..."
        [value]="search"
        (input)="search = $any($event.target).value"
        aria-label="Search employees"
      />
    </div>
  }

  @if (isLoading) {
    @for (item of [1, 2, 3, 4, 5]; track $index) {
      <ngx-skeleton-loader
        [theme]="{ height: '44px', background: '#e9edff', 'margin-bottom': '4px' }"
      />
    }
  } @else {
    <div class="custom-general-table">
      <div class="general-mater-table">
        <div class="general-table-header team-grid">
          <p>EMPLOYEE</p>
          <p>CONTACT</p>
          <p>COMPANY / BRANCH</p>
          <p>DEPT / GRADE</p>
          <p>SAP CODE</p>
        </div>

        @for (item of filteredTeam; track item.id) {
          <div class="general-table-row team-grid">
            <!-- Employee -->
            <div class="cell-item">
              <div class="emp-identity">
                <span class="emp-avatar">{{ initials(item) }}</span>
                <span class="emp-text">
                  <span class="cell-main truncate" [title]="item.name ?? ''">{{
                    clean(item.name) ?? "—"
                  }}</span>
                  <span class="cell-sub truncate" [title]="item.designation ?? ''">{{
                    clean(item.designation) ?? "—"
                  }}</span>
                  @if (clean(item.empId); as empId) {
                    <span class="emp-code truncate">#{{ empId }}</span>
                  }
                </span>
              </div>
            </div>

            <!-- Contact -->
            <div class="cell-item">
              <span class="cell-main truncate" [title]="item.emailId ?? ''">{{
                clean(item.emailId) ?? "—"
              }}</span>
              @if (clean(item.mobileNo); as phone) {
                <span class="cell-sub truncate">
                  <i class="fa fa-phone" aria-hidden="true"></i> {{ phone }}
                </span>
              }
            </div>

            <!-- Company / Branch -->
            <div class="cell-item">
              <span class="cell-main truncate" [title]="item.companyName ?? ''">{{
                clean(item.companyName) ?? "—"
              }}</span>
              @if (clean(item.branch); as branch) {
                <span class="cell-sub truncate" [title]="branch">{{ branch }}</span>
              }
            </div>

            <!-- Department / Grade -->
            <div class="cell-item">
              <span class="cell-main truncate" [title]="item.department ?? ''">{{
                clean(item.department) ?? "—"
              }}</span>
              <span class="cell-sub truncate">
                Grade: {{ clean(item.grade) ?? "—" }}
              </span>
            </div>

            <!-- SAP Code -->
            <div class="cell-item">
              <span class="cell-main truncate">{{ clean(item.sapCode) ?? "—" }}</span>
            </div>
          </div>
        } @empty {
          <div class="common-card no-data-wrap">
            <img src="assets/images/no-data-found.svg" />
            <p>No Record(s) Found</p>
          </div>
        }
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="btn btn-primary" (click)="close()">Close</button>
</mat-dialog-actions>
